module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/checkbox-6c37adb85e3e4b69d429bd40497cde46.svg";